import { Check, ArrowUpRight } from 'lucide-react';
import { Reveal, SectionHeading } from '../components/Reveal';
import { PRICING, SITE } from '../lib/site';

export const Pricing = () => (
  <section className="bg-brand-iceSoft py-20 lg:py-28" id="pricing" data-testid="pricing-section">
    <div className="container-x">
      <SectionHeading
        eyebrow="Pricing Plans"
        title="Start Small, Scale Big"
        sub="Lower costs above wants, combined adapting with all."
        center
      />

      <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-3">
        {PRICING.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08} className="h-full" data-testid={`pricing-plan-${p.id}`}>
            <div
              className={`relative flex h-full flex-col rounded-3xl border bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-lift ${
                p.featured ? 'border-brand-sky shadow-lift ring-1 ring-brand-sky/30' : 'border-brand-line shadow-card'
              }`}
            >
              {p.featured && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 rounded-full bg-brand-sky px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-widest text-white shadow-soft">
                  Best Value
                </span>
              )}

              <h3 className="text-lg font-bold tracking-tight text-brand-navy">{p.name}</h3>
              <p className="mt-1.5 min-h-[40px] text-sm text-slate-500">{p.blurb}</p>

              <p className="mt-5 flex items-baseline gap-1.5">
                <span className="text-4xl font-extrabold tracking-tight text-brand-navy">${p.price}</span>
                <span className="text-sm font-semibold text-slate-400">/month</span>
              </p>

              <a
                href={SITE.loginUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`pricing-choose-${p.id}`}
                className={`mt-6 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-bold transition-all hover:-translate-y-0.5 ${
                  p.featured
                    ? 'bg-brand-sky text-white shadow-soft hover:bg-brand-skyDeep hover:shadow-lift'
                    : 'border border-brand-line bg-white text-brand-navy hover:border-brand-lineBlue hover:shadow-card'
                }`}
              >
                Choose Plan
                <ArrowUpRight className="h-4 w-4" />
              </a>

              <ul className="mt-7 space-y-3 border-t border-slate-100 pt-6">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-brand-body">
                    <span className={`mt-0.5 flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full ${p.featured ? 'bg-brand-ice text-brand-skyDeep' : 'bg-emerald-50 text-emerald-600'}`}>
                      <Check className="h-3 w-3" strokeWidth={3} />
                    </span>
                    {f}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
